<template>
  <router-view />
</template>

<style lang="less">
@font-face {
  font-family: 'iconfont';  /* Project id 211302 */
  src: url('//at.alicdn.com/t/c/font_211302_d7gy0l5xzth.woff2?t=1777267138135') format('woff2'),
       url('//at.alicdn.com/t/c/font_211302_d7gy0l5xzth.woff?t=1777267138135') format('woff'),
       url('//at.alicdn.com/t/c/font_211302_d7gy0l5xzth.ttf?t=1777267138135') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

html, body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}
</style>
